import React, { FC } from 'react';

import { LicenseInfoTypeFragment, LicensePaymentState, LicenseType } from '@entities/billing';

import LicensesListItem from '../LicensesListItem/LicensesListItem';
import { LicensesModalAction } from '../../model/licensesModalReducer';
import { getModalUnpaidLicenseItem } from '../../model/getModalUnpaidLicenseItem';

import styles from './LicensesUnpaidList.module.scss';

interface LicensesUnpaidListProps {
  unpaidLicenses: LicenseType[];
  toEnableAutorenewal: string[];
  dispatch: (value: LicensesModalAction) => void;
  setSubscriptionCost: (licensesIds: string[]) => Promise<void>;
}

const LicensesUnpaidList: FC<LicensesUnpaidListProps> = ({
  unpaidLicenses,
  toEnableAutorenewal,
  dispatch,
  setSubscriptionCost,
}) => {
  const licenses = unpaidLicenses?.map((item) => getModalUnpaidLicenseItem(item, toEnableAutorenewal));

  const onChange = (item: LicenseInfoTypeFragment, value: boolean) => {
    if (value) {
      const currentToEnableAutorenewal = [...toEnableAutorenewal, item.id];
      dispatch({ type: 'setToEnableAutorenewal', toEnableAutorenewal: currentToEnableAutorenewal });
      setSubscriptionCost(currentToEnableAutorenewal);
    } else {
      const newToEnableAutorenewal = toEnableAutorenewal.filter((id) => id !== item.id);
      dispatch({ type: 'setToEnableAutorenewal', toEnableAutorenewal: newToEnableAutorenewal });
      setSubscriptionCost(newToEnableAutorenewal);
    }
  };

  return (
    <div className={styles.licensesUnpaidList}>
      {licenses?.map((item) => (
        <LicensesListItem
          item={item}
          key={`licenses_unpaid_list_item_${item.id}`}
          isChecked={item.isChecked}
          isGraceSubtitleVisible={item.paymentState === LicensePaymentState.Grace}
          isWaitPaymentSubtitleVisible={item.paymentState === LicensePaymentState.WaitPayment}
          onChange={(value) => onChange(item, value)}
        />
      ))}
    </div>
  );
};

export default React.memo(LicensesUnpaidList);
